<template>
  <div>
    <div v-if="formKey === 'brands'">
      <el-button v-if="!formItem.isPreview" type="primary" @click="formItem.is_open = true">选择跳转类型</el-button>
      <div v-if="Object.keys(formItem.value.result_map).length">
        <div v-for="(item, key) in formItem.value.result_map" :key="key">
          <span class="mr-20">{{ key }}</span>
          <span class="mr-20">{{ getOptionByValue(formItem.value.type_selection, item.type)?.label || '-' }}</span>
          <span>{{ getOptionByValue(item.options, item.value)?.label || '-' }}</span>
        </div>
      </div>
      <div v-if="!Object.keys(formItem.value.result_map).length && formItem.isPreview">-</div>
      <el-dialog
        title="品牌形象跳转配置"
        :visible.sync="formItem.is_open"
        :close-on-click-modal="false"
        :append-to-body="true"
        :modal-append-to-body="true"
        width="800px"
      >
        <brands v-if="formItem.is_open" ref="brands-ref" :form-item="formItem" :init-ops="initOps" />
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="formItem.is_open = false">取 消</el-button>
          <el-button size="mini" type="primary" @click="brandsConfirm(formItem)">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <div v-if="formKey === 'story_components'">
      <el-button v-if="!formItem.isPreview" type="primary" @click="formItem.is_open = true">选择转化组件</el-button>
      <div v-if="Object.keys(formItem.value.result_map).length">
        <div v-for="(item, key) in formItem.value.result_map" :key="key">
          <span class="mr-20">{{ key }}</span>
          <span class="mr-20">{{ getOptionByValue(formItem.value.type_selection, item.type)?.label || '-' }}</span>
          <span>{{ getOptionByValue(item.options, item.value)?.label || '-' }}</span>
        </div>
      </div>
      <div v-if="!Object.keys(formItem.value.result_map).length && formItem.isPreview">-</div>
      <el-dialog
        title="Story转化组件配置"
        :visible.sync="formItem.is_open"
        :close-on-click-modal="false"
        :append-to-body="true"
        :modal-append-to-body="true"
        width="800px"
      >
        <story-component v-if="formItem.is_open" ref="story-component-ref" :form-item="formItem" :init-ops="initOps" :data-map="getDataMap()" />
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="formItem.is_open = false">取 消</el-button>
          <el-button size="mini" type="primary" @click="storyComponentsConfirm(formItem)">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { component_props } from '@/views/fusion/investment/intelligence-create/components/main-view/components/step-form/model/props';
import { data_sharing_mixin } from '@/views/fusion/investment/intelligence-create/mixins/data-sharing';

export default {
  components: {
    'brands': () => import('./components/brands/index.vue'),
    'story-component': () => import('./components/story-component/index.vue'),
  },
  mixins: [data_sharing_mixin],
  props: {
    ...component_props,
  },
  methods: {
    /**
     * 根据值获取选项
     * @param {Object[]} options 选项
     * @param {number|string} val 值
     */
    getOptionByValue(options, val) {
      return options.find(({ value }) => value === val);
    },
    /**
     * 品牌形象跳转配置弹窗确认
     * @param form_item 表单项
     * @returns {void}
     */
    brandsConfirm(form_item) {
      const result = this.$refs['brands-ref']?.table_data || [];
      const is_valid = result.every(({ type, target }) => type?.value && target?.[type.value]?.value);
      if (is_valid) {
        result.forEach(({ advertiser_id, type, target }) => {
          Object.assign(form_item.value.result_map, { [advertiser_id]: {
            type: type.value,
            options: target[type.value].options,
            value: target[type.value].value,
          }});
        });
        form_item.is_open = false;
        this.$parent.$parent.$parent.validateField('brands.value');
      } else {
        this.$message.warning('请填写完整所有配置');
      }
    },
    /**
     * 获取数据表
     * @returns {Object}
     */
    getDataMap() {
      const form_context = this.local_sharing_data.getFormContext();
      const { dataController } = form_context.config;
      const getStoryComponentList = (advertiser_id, component_type) => dataController.getStoryComponentList(advertiser_id, { bilibili_params: { filtering: { component_type }}});

      return {
        '2': getStoryComponentList,
      };
    },
    /**
     * Story转化组件配置弹窗确认
     * @param form_item 表单项
     * @returns {void}
     */
    storyComponentsConfirm(form_item) {
      const result = this.$refs['story-component-ref']?.table_data || [];
      const is_valid = result.every(({ type, target }) => type?.value && target?.[type.value]?.value);
      if (is_valid) {
        result.forEach(({ advertiser_id, type, target }) => {
          Object.assign(form_item.value.result_map, { [advertiser_id]: {
            type: type.value,
            options: target[type.value].options,
            value: target[type.value].value,
          }});
        });
        form_item.is_open = false;
        this.$parent.$parent.$parent.validateField('story_components.value');
      } else {
        this.$message.warning('请填写完整所有配置');
      }
    },
  },
};
</script>
